
import { useState, useEffect } from 'react';

export default function LibraryHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/aa2a7cfdb1ee8f36062ccc9503dee264.jpg"
          alt="Resources Library background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/95 via-slate-900/90 to-amber-950/80" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
      </div>

      <div className="absolute top-32 right-16 w-80 h-80 bg-amber-500/15 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-16 left-16 w-72 h-72 bg-teal-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }} />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-20 pt-32">
        <div className="text-center">
          <div
            className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30 rounded-full mb-8">
              <i className="ri-folder-download-line text-amber-400" />
              <span className="text-amber-300 text-sm font-semibold">Free Downloads • Templates & Checklists</span>
            </div>
          </div>

          <h1
            className={`text-5xl lg:text-7xl font-bold text-white leading-tight mb-6 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            Resources
            <span className="block bg-gradient-to-r from-amber-400 via-orange-400 to-amber-500 bg-clip-text text-transparent">
              Library
            </span>
          </h1>

          <p
            className={`text-xl text-slate-300 leading-relaxed mb-10 max-w-2xl mx-auto transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            Professional templates, checklists, and business documents designed specifically for Australian tradies. Download free and start using today.
          </p>

          <div
            className={`flex flex-wrap justify-center gap-6 mb-12 transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            {[
              { value: '14+', label: 'Free Templates', icon: 'ri-file-copy-2-line' },
              { value: '38K+', label: 'Downloads', icon: 'ri-download-cloud-2-line' },
              { value: '7', label: 'Trade Categories', icon: 'ri-tools-line' },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl px-6 py-4 min-w-[140px]">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${stat.icon} text-amber-400 text-xl`} />
                </div>
                <div className="text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-slate-400 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          <div
            className={`flex flex-wrap justify-center gap-4 transition-all duration-700 delay-[400ms] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <a
              href="#library"
              className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-amber-400 to-orange-500 text-slate-900 rounded-full font-bold hover:from-amber-500 hover:to-orange-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40 hover:scale-105"
            >
              <span>Browse Library</span>
              <i className="ri-arrow-down-line" />
            </a>
            <a
              href="#request"
              className="inline-flex items-center gap-3 px-8 py-4 border border-white/30 text-white rounded-full font-semibold hover:bg-white/10 hover:border-amber-500/30 transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105"
            >
              <span>Request a Template</span>
              <i className="ri-mail-send-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
